// extracted by mini-css-extract-plugin
export default {"app":"AppLinks-module--app--d7ef2","active":"AppLinks-module--active--b630a","mobile":"AppLinks-module--mobile--e9c12","wide":"AppLinks-module--wide--f2683"};